import { render, staticRenderFns } from "./ClientPays.vue?vue&type=template&id=71f52ae2"
import script from "./ClientPays.vue?vue&type=script&lang=js"
export * from "./ClientPays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports